export const flowStriimline = {
    nodeConnectionBorder: "#BCC9D6", // @greyscale_300
    nodeConnectionBorderActive: "#8091A3", // @greyscale_600 (.jsplumb-connector)
    lineInColor: "#346CC2", // @flow_in_color
    lineOutColor: "#2E8071", // @flow_out_color
    lineCrashColor: "#DB2A4A" // @critical_500
}
